import styled from 'styled-components'

export const Spacer = styled.div`
  padding: 30px 40px;
`
